<div *ngIf="accessdenied" class="row">
    <div class="col-md-12 no-padding">
        <app-access-denied></app-access-denied>
    </div>
</div>
<div *ngIf="!accessdenied" class="row">
    <div class="col-md-8 no-padding">
        <div class="row" style="margin-bottom: 15px;">
            <div class="col-xs-12 col-sm-12 col-lg-12 largTextbox no-padding" style="box-shadow: 0 2px 6px 0 hsl(0deg 0% 0% / 20%); background-color: #00a6b6; color: white; border-top-right-radius: 5px; border-top-left-radius: 5px; ">
                <h6 style="font-size: 14px; height: 35px; margin: 0px; padding: 10px; border-top-left-radius: 5px; border-top-right-radius: 5px;" class="sub-title">
                    Change password
                </h6>
            </div>
            <div class="col-xl-12 block-style" style="border-top-left-radius: 0; border-top-right-radius: 0;">
                <div class="row">
                    <div class="form-group col-md-12 col-sm-12 col-xs-12  no-padding" style="margin-bottom:20px">
                        <div class="form-floating" style="margin-right: 5px;">
                            <input [(ngModel)]="currentPassword" type="password" class="form-control" id="floatingInputValueSubject">
                            <label for="floatingInputValueSubject">Current password</label>
                        </div>
                    </div>
                    <div class="form-group col-md-12 col-sm-12 col-xs-12  no-padding" style="margin-bottom:20px">
                        <div class="form-floating" style="margin-right: 5px;">
                            <input [(ngModel)]="newPassword" type="password" class="form-control" id="floatingInputValueSubject">
                            <label for="floatingInputValueSubject">New password</label>
                        </div>
                    </div>
                    <div class="form-group col-md-12 col-sm-12 col-xs-12  no-padding" style="margin-bottom:20px">
                        <div class="form-floating" style="margin-right: 5px;">
                            <input [(ngModel)]="confirmPassword" type="password" class="form-control" id="floatingInputValueSubject">
                            <label for="floatingInputValueSubject">Confirm new password</label>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-xl-12 text-right">
                        <button [disabled]="btnSaveDisabled" style="float: right;" (click)="save()" class="btn mygistec-main-btn">{{btnSaveText}}</button>
                    </div>

                </div>
            </div>
        </div>

    </div>
    <div class="col-md-4" style="padding-right: 0px; padding-left: 30px;">
        <app-profile-edit-box></app-profile-edit-box>
    </div>
</div>
